import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import { useMemo } from 'react';
import { AvatarType } from '@mavatar/3d-avatar';
import { TutorChatL1 } from '@mavatar/melingo-voice-and-avatar-sdk';

import tutorAvatarGif from '@/assets/images/tutorAvatarSdk2.png';
import tutorAvatar from '@/assets/images/tutorAvatarSdk2.png';
import tutorAvatarFGif from '@/assets/images/tutorAvatarF6_40.gif';
import tutorAvatarF from '@/assets/images/tutorAvatarF6_40.png';

const UseAzureLanguageSettings = (gender: 'MAN' | 'FEMALE' = 'FEMALE') => {
  const { user } = useAppSelector(authSelector);

  const sttLanguage: string = useMemo(() => {
    if ((window as any).stt_language) {
      return (window as any).stt_language;
    }

    if ((user?.metadata?.organizationDetails?.country || '').toLowerCase() === 'india') {
      return 'en-IN';
    }

    return 'en-US';
  }, [user]);

  const ttsVoices = useMemo(() => {
    const voicesM: {
      [lang: string]: string;
    } = {
      L1: 'en-US-AndrewMultilingualNeural',
      [TutorChatL1.EN]: 'en-US-AndrewMultilingualNeural',
      'en-US': 'en-US-AndrewMultilingualNeural',
      'en-IN': 'en-IN-ArjunIndicNeural',
      [TutorChatL1.PT]: 'pt-PT-DuarteNeural',
      'pt-BR': 'pt-BR-MacerioMultilingualNeural',
      'pt-PT': 'pt-PT-DuarteNeural',
      [TutorChatL1.SP]: 'es-ES-TristanMultilingualNeural',
      'es-ES': 'es-ES-TristanMultilingualNeural',
      [TutorChatL1.HE]: 'he-IL-AvriNeural',
      'he-IL': 'he-IL-AvriNeural',
    };

    // en-US-AvaMultilingualNeural

    const voicesF: {
      [lang: string]: string;
    } = {
      L1: 'en-US-EmmaMultilingualNeural',
      [TutorChatL1.EN]: 'en-US-EmmaMultilingualNeural',
      'en-US': 'en-US-EmmaMultilingualNeural',
      'en-IN': 'en-IN-AartiIndicNeural',
      [TutorChatL1.PT]: 'pt-PT-FernandaNeural',
      'pt-BR': 'pt-BR-ThalitaMultilingualNeural',
      'pt-PT': 'pt-PT-FernandaNeural',
      [TutorChatL1.SP]: 'es-ES-XimenaMultilingualNeural',
      'es-ES': 'es-ES-XimenaMultilingualNeural',
      [TutorChatL1.HE]: 'he-IL-HilaNeural',
      'he-IL': 'he-IL-HilaNeural',
    };

    const voices = gender === 'MAN' ? voicesM : voicesF;

    //const nativeLanguage = user?.metadata?.languagePreferences?.nativeLanguage || 'en';
    //
    //if (nativeLanguage === 'pt') {
    //  voices.L1 = 'pt-BR-MacerioMultilingualNeural';
    //  voices[TutorChatL1.EN] = 'pt-BR-MacerioMultilingualNeural';
    //  voices['en-US'] = 'pt-BR-MacerioMultilingualNeural';
    //  voices[TutorChatL1.PT] = 'pt-BR-MacerioMultilingualNeural';
    //  voices['pt-BR'] = 'pt-BR-MacerioMultilingualNeural';
    //}
    //
    //if (nativeLanguage === 'es') {
    //  voices.L1 = 'es-ES-TristanMultilingualNeural';
    //  voices[TutorChatL1.EN] = 'es-ES-TristanMultilingualNeural';
    //  voices['en-US'] = 'es-ES-TristanMultilingualNeural';
    //  voices[TutorChatL1.SP] = 'es-ES-TristanMultilingualNeural';
    //  voices['es-ES'] = 'es-ES-TristanMultilingualNeural';
    //}
    //
    //if (nativeLanguage === 'he') {
    //  voices.L1 = 'he-IL-AvriNeural';
    //}

    return voices;
  }, [user, gender]);

  const [avatarType, avatarIcon, avatarGif, avatarAccessories] = useMemo(() => {
    const avatarType =
      gender === 'MAN' ? AvatarType.AVATARSDK_MAN_2 : AvatarType.AVATARSDK_FEMALE_6_40_1;
    const avatarIcon = gender === 'MAN' ? tutorAvatar : tutorAvatarF;
    const avatarGif = gender === 'MAN' ? tutorAvatarGif : tutorAvatarFGif;
    const avatarAccessories: {
      [key: string]: boolean;
    } =
      gender === 'MAN'
        ? {
            glasses: true,
          }
        : {
            earring: true,
          };

    return [avatarType, avatarIcon, avatarGif, avatarAccessories];
  }, [gender]);

  return {
    sttLanguage,
    avatarType,
    avatarIcon,
    avatarGif,
    avatarAccessories,
    ttsVoices,
  };
};

export default UseAzureLanguageSettings;
